import { useEffect } from 'react';
import ErrorModalManager from './components/ErrorModalManager/ErrorModalManager';
import NotificationManager from './components/NotificationManager/NotificationManager';
import { useErrorContext } from './contexts/ErrorContext';
import { setGlobalErrorHandler } from './lib/axios';
import UploadManager from './components/UploadManager/UploadManager';
import DownloadManager from './components/DownloadManager/DownloadManager';
import RoutesList from './lib/RoutesList';
import CookieConsentBanner from './components/CookieConsentBanner/CookieConsentBanner';
import GALocationTracker from './components/GALocationTracking/GALocationTracking';
import FeedbackFloatingButton from './components/FeedbackWidget/FeedbackFloatingButton';

function App() {
  const { addError } = useErrorContext();

  useEffect(() => {
    setGlobalErrorHandler(addError);
  }, [addError]);

  return (
    <>
      <UploadManager />
      <DownloadManager />
      <ErrorModalManager />
      <NotificationManager />
      <RoutesList />
      <CookieConsentBanner />
      <FeedbackFloatingButton />
      <GALocationTracker />
    </>
  );
}

export default App;
